import sanitizeHtml from './sanitizeHtml';

// eslint-disable-next-line import/prefer-default-export
export { sanitizeHtml };
